require("./bootstrap");

import App from "./App.vue";
import Vue from "vue";
import vuetify from "./plugins/vuetify";
import router from "./plugins/router";
import http from "./plugins/http";
import auth from "./plugins/auth";
import i18n from "./plugins/i18n";
import api from "./plugins/api";
import preventNull from "./filters/preventNull";
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import fr from 'dayjs/locale/fr'
import Config from './config.singleton'

dayjs.locale(fr)
dayjs.extend(LocalizedFormat)

String.prototype.toDate = function () {
    return dayjs(this).format('L');
}

String.prototype.toDateTime = function () {
    return dayjs(this).format('L LT');
}


Vue.filter('preventNull', preventNull)

(async () => {
    await Config.fetch()

    new Vue({
        http,
        router,
        i18n,
        auth,
        api,
        vuetify,
        el: "#app",
        methods: {
            getFilters(name, default_filters = []) {
                return {...default_filters, ...JSON.parse(localStorage.getItem(name + '_filters'))};
            },
            saveFilters(name, filters) {
                Object.keys(filters).forEach((key) => {
                    if (filters[key] == null) {
                        delete filters[key];
                    }
                });

                localStorage.setItem(name + '_filters', JSON.stringify(filters));
            },
            clearStorage() {
                localStorage.clear()
            }
        },
        render: (h) => h(App),
    }).$mount("#app");
})()
